import { aptEnsureLoaded } from "../../apt-ensure-loaded"
import { analysisStore } from "../analysis/analysis-store"
import { anomalyStore } from "./_components/anomaly/anomaly-store"
import { kpiMetricStore } from "./_components/kpi-metric/kpi-metric-store"
import { resourceTrendStore } from "./_components/resource-trend/resource-trend-store"
import { topUsageRankStore } from "./_components/top-rank/top-rank-store"
import { overviewBundle } from "./overview-const"

export const overviewLoader = async ({ params }) => {
  await aptEnsureLoaded(params)

  await Promise.all([
    kpiMetricStore.getState().apiGetKpiMetric(),
    resourceTrendStore.getState().apiGetResourceTrend({
      period: overviewBundle.tabs[0].value
    }),
    analysisStore.getState().apiGetLeakUnits({
      dong: "all"
    }),
    anomalyStore.getState().apiGetNegativeUsage(),
    topUsageRankStore.getState().apiGetTopUsageRank()
  ])

  return null
}
